module.exports = __webpack_public_path__ + "static/img/bonus_3.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_3.png
// module id = dH3V
// module chunks = 0